export default "__VITE_ASSET__85f45417__"